import ProfilLayout from "../../ProfilLayout/ProfilLayout";
import {
    EstablishementInfosContext,
    CustomModalContext,
    LayoutBarContext,
    InitDataContext,
} from "../../../../contexts";
import { useCallback, useContext, useEffect, useMemo } from "react";
import EditPhoneNumberForm from "./Forms/EditPhoneNumberForm";
import ProfilCardsList from "../../ProfilCardsList/ProfilCardsList";
// import EditSynerpaNumFrom from "./Forms/EditSynerpaNumFrom";
import EditCompanyNameForm from "./Forms/EditCompanyNameForm";
import EditSiretForm from "./Forms/EditSiretFrom";
import EditAdressForm from "./Forms/EditAdressForm";
import EditCategoryForm from "./Forms/EditCategoryForm";
import { buildStringAdress } from "../../../../helpers";
import ProfilHome from "../../ProfilHome";
import { sessionStorageKey, establishementKey } from "../../../../consts";
import { useLocalStorage } from "../../../../hooks";
import { Session } from "@/src/types";
import { putAdressById, putEstablishment } from "../../../../services";
import { fetchEstbalishment } from "../Common/services";

export default function EstablishmentInfos() {
    const { updateEstablishementInfos, ...establishementInfos } = useContext(
        EstablishementInfosContext
    );

    const { updateContent } = useContext(LayoutBarContext);

    const { updateModal, updateIsCustomModalActive } =
        useContext(CustomModalContext);

    const { storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);

    const { ...dataInit } = useContext(InitDataContext);

    const {
        auth: { user: currentUser },
    } = session;

    const getEstablishmentCategoryFromStorage = () => {
        const establishmentGroupsFromContext =
            dataInit[establishementKey].establishmentGroups;
        const establishmentTypesFromContext =
            dataInit[establishementKey].establishmentTypes;

        if (
            establishmentGroupsFromContext.length &&
            establishmentTypesFromContext.length
        ) {
            return {
                establishmentGroups: establishmentGroupsFromContext,
                establishmentTypes: establishmentTypesFromContext,
            };
        }
        const {
            [establishementKey]: {
                establishmentGroups: storedEstablishmentGroups,
                establishmentTypes: storedEstablishmentTypes,
            },
        } = session;
        return {
            establishmentGroups: storedEstablishmentGroups,
            establishmentTypes: storedEstablishmentTypes,
        };
    };

    const {
        establishmentGroups: _establishmentGroups,
        establishmentTypes: _establishmentTypes,
    } = getEstablishmentCategoryFromStorage();

    const establishement = currentUser.establishment;

    const _updateEstablishementInfos = (value: any) => {
        updateEstablishementInfos({
            ...establishementInfos,
            establishment: {
                ...establishementInfos.establishment,
                ...value,
            },
        });
    };

    const _updateUserInfos = (key: string, value: any) => {
        updateEstablishementInfos({
            ...establishementInfos,
            [key]: value,
        });
    };

    const handlePutEstablishment = useCallback(async (formData: any) => {
        if (formData) {
            const establishmentGroup = formData?.establishment
                ?.establishmentGroup
                ? formData?.establishment?.establishmentGroup.id
                : establishementInfos?.establishment?.establishmentGroup?.id;

            const establishmentType = formData?.establishment?.establishmentType
                ? formData?.establishment.establishmentType.id
                : establishementInfos?.establishment.establishmentType.id;

            const putPayload = {
                ...establishementInfos.establishment,
                ...formData,
                billingAddress:
                    establishementInfos.establishment.billingAddress.id,
                contactAddress:
                    establishementInfos.establishment.contactAddress.id,
                establishmentGroup,
                establishmentType,
            };

            return await putEstablishment(putPayload);
        }
    }, []);

    const establishementInfosProfilCards = useMemo(() => {
        return [
            {
                key: "adress",
                value: buildStringAdress(
                    establishementInfos?.establishment?.contactAddress
                ),
                label: "Adresse postale",
                onClick: async () => {
                    updateModal({
                        content: (
                            <EditAdressForm
                                onSubmit={async (formData: any) => {
                                    const adressData = {
                                        contactAddress: {
                                            ...formData.contactAddress,
                                        },
                                        billingAddress:
                                            formData.useDiffrentBillingAddress
                                                ? { ...formData.billingAddress }
                                                : {
                                                      ...formData.contactAddress,
                                                  },
                                    };

                                    const putContactAddressRes =
                                        await putAdressById(
                                            adressData.contactAddress
                                        );

                                    const putBillingAddressRes =
                                        await putAdressById(
                                            adressData.billingAddress
                                        );

                                    const isAddressUpdated =
                                        !putContactAddressRes.detail &&
                                        !putBillingAddressRes.detail;
                                    if (isAddressUpdated) {
                                        _updateEstablishementInfos(adressData);
                                        updateIsCustomModalActive(false);
                                    }
                                }}
                                defaultValue={{
                                    contactAddress:
                                        establishementInfos.establishment
                                            .contactAddress,
                                    billingAddress:
                                        establishementInfos.establishment
                                            .billingAddress,
                                }}
                            />
                        ),
                        title: "Modifier l’adresse postale de l’établissement",
                    });
                    updateIsCustomModalActive(true);
                },
            },
            //######## user
            {
                key: "phoneNumber",
                value: establishementInfos?.phoneNumber,
                label: "Numéro de téléphone",
                onClick: async () => {
                    updateModal({
                        content: (
                            <EditPhoneNumberForm
                                onSubmit={(formData: any) => {
                                    _updateUserInfos(
                                        "phoneNumber",
                                        formData.phoneNumber
                                    );
                                    updateIsCustomModalActive(false);
                                }}
                                defaultValue={{
                                    phoneNumber:
                                        establishementInfos.phoneNumber,
                                }}
                            />
                        ),
                        title: "Modifier le numéro de téléphone",
                    });
                    updateIsCustomModalActive(true);
                },
            },
            {
                key: "email",
                value: establishementInfos.email,
                label: "Adresse mail",
                // onClick: async () => {
                //     updateModal({
                //         content: (
                //             <EditEmailForm
                //                 onSubmit={(formData: any) => {
                //                     _updateUserInfos("email", formData.email);
                //                     updateIsCustomModalActive(false);
                //                 }}
                //                 defaultValue={{
                //                     email: establishementInfos.email,
                //                 }}
                //             />
                //         ),
                //         title: "Modifier l'adress email",
                //     });
                //     updateIsCustomModalActive(true);
                // },
            },
            //######## user
            {
                key: "category",
                value: establishementInfos?.establishment?.establishmentType
                    ?.name,
                label: "Catégorie",
                onClick: async () => {
                    updateModal({
                        content: (
                            <EditCategoryForm
                                onSubmit={async (formData: any) => {
                                    const puttingEstablishementRes =
                                        await handlePutEstablishment(formData);
                                    if (!puttingEstablishementRes.detail) {
                                        _updateEstablishementInfos(formData);
                                        updateIsCustomModalActive(false);
                                    }
                                }}
                                defaultValue={{
                                    region:
                                        establishementInfos?.establishment
                                            .region?.id + "",
                                    establishmentType:
                                        establishementInfos?.establishment
                                            .establishmentType?.id + "",
                                    establishmentGroup:
                                        establishementInfos?.establishment
                                            .establishmentGroup?.id + "",
                                }}
                            />
                        ),
                        title: "Modifier la catégorie de l’établissement",
                    });
                    updateIsCustomModalActive(true);
                },
            },
            // {
            //     key: "synerpaNum",
            //     value: establishementInfos?.establishment?.synerpaNum,
            //     label: "Numéro adhérent SYNERPA",
            //     onClick: async () => {
            //         updateModal({
            //             content: (
            //                 <EditSynerpaNumFrom
            //                     onSubmit={async (formData: any) => {
            //                         const puttingEstablishementRes =
            //                             await handlePutEstablishment(formData);
            //                         if (!puttingEstablishementRes.detail) {
            //                             _updateEstablishementInfos(formData);
            //                             updateIsCustomModalActive(false);
            //                         }
            //                     }}
            //                     defaultValue={{
            //                         synerpaNum:
            //                             establishementInfos.establishment
            //                                 .synerpaNum,
            //                     }}
            //                 />
            //             ),
            //             title: "Modifier le numéro de SIRET",
            //         });
            //         updateIsCustomModalActive(true);
            //     },
            // },
            {
                key: "siret",
                value: establishementInfos?.establishment?.siret,
                label: "Numéro de SIRET",
                onClick: async () => {
                    updateModal({
                        content: (
                            <EditSiretForm
                                onSubmit={async (formData: any) => {
                                    const puttingEstablishementRes =
                                        await handlePutEstablishment(formData);
                                    if (!puttingEstablishementRes.detail) {
                                        _updateEstablishementInfos(formData);
                                        updateIsCustomModalActive(false);
                                    }
                                }}
                                defaultValue={{
                                    siret: establishementInfos.establishment
                                        .siret,
                                }}
                            />
                        ),
                        title: "Modifier le numéro de SIRET",
                    });
                    updateIsCustomModalActive(true);
                },
            },
            {
                key: "companyName",
                value: establishementInfos?.establishment?.companyName,
                label: "Raison sociale",
                onClick: async () => {
                    updateModal({
                        content: (
                            <EditCompanyNameForm
                                onSubmit={async (formData: any) => {
                                    const puttingEstablishementRes =
                                        await handlePutEstablishment(formData);
                                    if (!puttingEstablishementRes.detail) {
                                        _updateEstablishementInfos(formData);
                                        updateIsCustomModalActive(false);
                                    }
                                }}
                                defaultValue={{
                                    companyName:
                                        establishementInfos.establishment
                                            .companyName,
                                }}
                            />
                        ),
                        title: "Modifier la raison sociale",
                    });
                    updateIsCustomModalActive(true);
                },
            },
        ];
    }, [establishementInfos]);

    const fetchGeneralEstablishmentData = useCallback(
        async (establishementId: number) => {
            return await fetchEstbalishment(establishementId);
        },
        []
    );

    const fetchEstablishmentInfos = useCallback(async () => {
        if (establishement) {
            const generalEstablishmentData =
                await fetchGeneralEstablishmentData(establishement);

            if (generalEstablishmentData) {
                const establishmentType = _establishmentTypes.find(
                    (e) => e.id === generalEstablishmentData.establishmentType
                );

                const establishmentGroup = _establishmentGroups.find(
                    (e) => e.id === generalEstablishmentData.establishmentType
                );

                updateEstablishementInfos({
                    ...currentUser,
                    establishment: {
                        ...generalEstablishmentData,
                        establishmentType: {
                            id: generalEstablishmentData.establishmentType,
                            name: establishmentType?.name ?? "",
                            code: establishmentType?.code ?? "",
                        },
                        establishmentGroup: {
                            id: generalEstablishmentData.establishmentGroup,
                            name: establishmentGroup?.name ?? "",
                            code: establishmentGroup?.code ?? "",
                        },
                    },
                });
            }
        }
    }, [updateEstablishementInfos, fetchGeneralEstablishmentData]);

    useEffect(() => {
        fetchEstablishmentInfos();
    }, [fetchEstablishmentInfos]);

    return (
        <ProfilLayout
            headerTitle={"Informations sur l’établissement"}
            onBackClick={() => {
                updateContent(<ProfilHome />);
            }}
        >
            <ProfilCardsList profilCardItems={establishementInfosProfilCards} />
        </ProfilLayout>
    );
}
